export const AUTH = {
  loginForm: 'login-form',
  loginEmail: 'login-email-input',
  loginPassword: 'login-password-input',
  loginSubmit: 'login-submit-btn',
  loginToRegister: 'login-to-register-link',
  registerForm: 'register-form',
  registerName: 'register-name-input',
  registerEmail: 'register-email-input',
  registerPassword: 'register-password-input',
  registerSubmit: 'register-submit-btn',
  registerToLogin: 'register-to-login-link',
  authError: 'auth-error-message',
  logoutBtn: 'logout-btn',
  forgotPassword: 'forgot-password-page',
  forgotEmail: 'forgot-email-input',
  forgotSubmit: 'forgot-submit-btn',
  forgotDone: 'forgot-done-message',
  forgotLink: 'login-forgot-password-link',
  resetPage: 'reset-password-page',
  resetPassword: 'reset-password-input',
  resetConfirm: 'reset-confirm-input',
  resetSubmit: 'reset-submit-btn',
  resetError: 'reset-error-message',
};
